import Dexie from 'dexie';

const db = new Dexie('QAppDB');

db.version(1).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    synced
  `,
  
  todo: `
    ++id,
    user_id,
    date,
    column,
    synced
  `,
  
  todo_item: `
    ++id,
    todo_id,
    order,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status
  `
});

db.version(2).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  tasks: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  task_items: `
    ++id,
    task_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `
}).upgrade(tx => {
  // Migration: adicionar campos padrão para registros existentes
  return Promise.all([
    tx.table('flows').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('flow_accounts').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('flow_categories').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('flow_accounts_history').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('budgets').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('health_records').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('trips').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('places').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('todo').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('todo_item').toCollection().modify(item => {
      item.updated_at = item.created_at || new Date().toISOString();
      item.local_updated_at = null;
    }),
    tx.table('sync_queue').toCollection().modify(item => {
      item.conflict_status = 'none';
    })
  ]);
});

db.version(3).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  tasks: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  task_items: `
    ++id,
    task_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `
}).upgrade(async tx => {
  // Migration: renomear tasks para todo e task_items para todo_item
  try {
    // Migrar dados de tasks para todo
    const tasks = await tx.table('tasks').toArray();
    if (tasks.length > 0) {
      await tx.table('todo').bulkAdd(tasks);
      await tx.table('tasks').clear();
    }
  } catch (error) {
    console.log('Migration tasks -> todo:', error);
  }
  
  try {
    // Migrar dados de task_items para todo_item (renomeando task_id para todo_id)
    const taskItems = await tx.table('task_items').toArray();
    if (taskItems.length > 0) {
      const todoItems = taskItems.map(item => {
        const newItem = { ...item };
        newItem.todo_id = item.task_id;
        delete newItem.task_id;
        return newItem;
      });
      await tx.table('todo_item').bulkAdd(todoItems);
      await tx.table('task_items').clear();
    }
  } catch (error) {
    console.log('Migration task_items -> todo_item:', error);
  }
});

db.version(4).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todos: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo_items: `
    ++id,
    todo_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo_item: `
    ++id,
    todo_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `
}).upgrade(async tx => {
  // Migration: renomear todos para todo e todo_items para todo_item
  // Esta migration migra dados das stores antigas para as novas
  try {
    // Migrar dados de 'todos' para 'todo'
    const todos = await tx.table('todos').toArray();
    if (todos.length > 0) {
      // Criar store 'todo' se não existir e migrar dados
      const todoStore = tx.table('todo');
      await todoStore.bulkAdd(todos);
      await tx.table('todos').clear();
    }
  } catch (error) {
    console.log('Migration todos -> todo:', error);
  }
  
  try {
    // Migrar dados de 'todo_items' para 'todo_item'
    const todoItems = await tx.table('todo_items').toArray();
    if (todoItems.length > 0) {
      // Criar store 'todo_item' se não existir e migrar dados
      const todoItemStore = tx.table('todo_item');
      await todoItemStore.bulkAdd(todoItems);
      await tx.table('todo_items').clear();
    }
  } catch (error) {
    console.log('Migration todo_items -> todo_item:', error);
  }
});

db.version(5).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo_item: `
    ++id,
    todo_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `
});

db.version(6).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo_item: `
    ++id,
    todo_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notepad_clusters: `
    ++id,
    user_id,
    name,
    color,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    cluster_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `
}).upgrade(async tx => {
  // Migration: adicionar cluster_id null para todas as notas existentes
  const notesStore = tx.table('notes');
  const allNotes = await notesStore.toArray();
  
  for (const note of allNotes) {
    if (note.cluster_id === undefined) {
      await notesStore.update(note.id, { cluster_id: null });
    }
  }
});

db.version(7).stores({
  flows: `
    ++id,
    user_id,
    date,
    flow_type,
    categ_l0,
    categ_l1,
    categ_l2,
    std_value,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts: `
    ++id,
    user_id,
    account_name,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_categories: `
    ++id,
    user_id,
    categ_l0,
    categ_l1,
    categ_l2,
    category_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  flow_accounts_history: `
    ++id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  budgets: `
    ++id,
    user_id,
    date,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `,
  
  health_records: `
    ++id,
    user_id,
    date,
    type,
    area,
    updated_at,
    local_updated_at,
    synced
  `,
  
  trips: `
    ++id,
    user_id,
    start_date,
    end_date,
    updated_at,
    local_updated_at,
    synced
  `,
  
  places: `
    ++id,
    user_id,
    trip_id,
    country,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo: `
    ++id,
    user_id,
    date,
    column,
    updated_at,
    local_updated_at,
    synced
  `,
  
  todo_item: `
    ++id,
    todo_id,
    order,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notepad_clusters: `
    ++id,
    user_id,
    name,
    color,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  notes: `
    ++id,
    user_id,
    cluster_id,
    title,
    content,
    created_at,
    updated_at,
    local_updated_at,
    synced
  `,
  
  sync_queue: `
    ++id,
    method,
    url,
    timestamp,
    status,
    conflict_status
  `,
  
  id_mapping: `
    ++id,
    temp_id,
    real_id,
    store_name,
    created_at
  `
}).upgrade(async tx => {
  // Migration: criar índices para id_mapping
  // Dexie cria índices automaticamente baseado na definição do store
});

db.version(8).stores({
  flow_accounts_history: `
    ++id,
    user_id,
    account_id,
    historical_date,
    updated_at,
    local_updated_at,
    synced
  `
});

db.version(9).stores({
  budgets: null,

  budget_plans: `
    ++id,
    user_id,
    date,
    updated_at,
    local_updated_at,
    synced
  `,

  budget_plan_items: `
    ++id,
    user_id,
    plan_id,
    class_l0,
    budget_type,
    updated_at,
    local_updated_at,
    synced
  `
});

db.version(10).stores({
  planner_projects: `
    ++id,
    user_id,
    updated_at,
    local_updated_at,
    synced
  `,

  planner_project_columns: `
    ++id,
    user_id,
    project,
    order,
    updated_at,
    local_updated_at,
    synced
  `,

  planner_project_cards: `
    ++id,
    user_id,
    project,
    column,
    order,
    updated_at,
    local_updated_at,
    synced
  `
});

export default db;
